import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators'; // add manually 

@Injectable({
  providedIn: 'root'
})
export class CourseService {
  baseUrl = environment.baseUrl + 'course/';
  constructor(private http: HttpClient) { }

  active: any;

  getCourseList() {
    return this.http.get(this.baseUrl );
  }

  isCourseActive() {
    return this.http.get<boolean[]>(this.baseUrl + 'GetActiveCourse');// was string[] from the controller return datatype
  }

  checkIfActive() {
    // console.log("Is this active?");
    this.isCourseActive().subscribe((activeList: boolean[]) => {

        // console.log( " activeList: " + activeList[0].toString());
    if(activeList[0].toString() != 'true') {
        // console.log("activeList[0].toString");
        return false;
      } else {
        return true;
      }   
    }, error => {
      //this.alertify.error(error); //  'Failed to loginsss');
    }
    );
  }

  setMaintenanceMode(ppp: string) {
    // console.log("set Maintenance Mode");
    // console.log(this.baseUrl + 'SetMaintenanceMode/' + ppp);
    return this.http.post(this.baseUrl + 'SetMaintenanceMode/' + ppp, null);
  }

}
